import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndColsPricing } from "pages/users/utils/functions";
import { useNavigate } from "react-router-dom";
import { Pricing } from "pages/users/Users";
import useWindowDimensions from "common/functions";

interface ITable {
	data: Pricing;
	selectedFilter?: string;
	setNewSort: (value: string) => void;
	shouldReset: (value: boolean) => void;
	reset: boolean;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
	setEditModel: (value: boolean) => void;
	setEditModelData: (value: any) => void;
	users: any;
	setUsers: any;
	handleOpenPlan: Function;
	setPricingRecord: any;
}

const PricingTable: React.FC<ITable> = ({
	offset,
	setOffset,
	data,
	setNewSort,
	shouldReset,
	reset,
	length,
	limit,
	setEditModel,
	setEditModelData,
	users,
	setUsers,
	handleOpenPlan,
	setPricingRecord
}) => {
    
	const navigate = useNavigate();

	const { width } = useWindowDimensions();

	const [isAsc, setIsAsc] = useState({ sessions: false, energyInKWH: false, revenue: false });
	const [isDesc, setIsDesc] = useState({ sessions: false, energyInKWH: false, revenue: false });

	const { columns, rows } = computeRowsAndColsPricing(data,
		navigate,
		(value) => setNewSort(value),
		shouldReset,
		reset,
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value),
		setEditModel,
		setEditModelData,
		users,
		setUsers,
		handleOpenPlan,
		setPricingRecord
	);


	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : 'small'}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: Number(limit),
				showSizeChanger: false
			}}
			bordered />
	);
};

export default PricingTable;
